import(/* webpackMode: "eager", webpackExports: ["TabsComponent"] */ "/vercel/path0/apps/web/app/discover/components/TabsComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SideNavigation"] */ "/vercel/path0/apps/web/modules/SideNavigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNavigationBarComponent"] */ "/vercel/path0/apps/web/modules/TopNavigationBar/TopNavigationBar.tsx");
